
export const DEFAULTREDIRECT = {
  ADMIN: 'pages/admin',
  CLIENT: 'pages/client',
};
